function isAppPage() {
  var pathName = window.location.pathname;
  return (
    window.location.href.includes('/index.html') ||
    window.location.href.includes('/responsive.html') ||
    pathName.charAt(pathName.length - 1) === '/'
  );
}

function isLoginPage() {
  return window.location.href.includes('/login.html');
}

function isEmbeddedPage() {
  return window.location.href.includes('/embedded.html');
}

function isRegistrationPage() {
  return window.location.href.includes('/registration.html');
}

function isPublicRoute() {
  return (
    window.location.href.includes('/reg/') ||
    window.location.href.includes('/terms') ||
    window.location.href.includes('/landing')
  );
}

// route which is callable logged in an not logged in
function isHybridRoute() {
  return window.location.href.includes('/terms');
}

export {
  isAppPage,
  isLoginPage,
  isEmbeddedPage,
  isRegistrationPage,
  isPublicRoute,
  isHybridRoute
};
